// src/components/BoardOfEd/components/Program3600.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_3600_CONFIG = {
  fullName: "TECHNOLOGY SUPPORT",
  docId: "3600",

  fieldDefs: [
    // Positions
    {
      key: "positionsAdmin",
      label: "Positions – Administrative",
      valueType: "count",
      sources: [{ block: "Positions", key: "Administrative" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsCoordinators",
      label: "Positions – Coordinators",
      valueType: "count",
      sources: [{ block: "Positions", key: "Coordinators" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsTechSpecialists",
      label: "Positions – Technology Specialists",
      valueType: "count",
      sources: [{ block: "Positions", key: "Technology Specialists" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsSecretarial",
      label: "Positions – Secretarial",
      valueType: "count",
      sources: [{ block: "Positions", key: "Secretarial" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsParaprofessionals",
      label: "Positions – Paraprofessionals",
      valueType: "count",
      sources: [{ block: "Positions", key: "Paraprofessionals" }],
      group: "positions",
      defaultVisible: false,
    },

    // Salaries
    {
      key: "salariesAdmin",
      label: "Salaries – Administrative",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Administrative" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesCoordinators",
      label: "Salaries – Coordinators",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Coordinators" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesTechSpecialists",
      label: "Salaries – Technology Specialists",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Technology Specialists" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesTechMaintenancePT",
      label: "Salaries – Technology Maintenance, P-T",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Technology Maintenance, P-T" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSecretarial",
      label: "Salaries – Secretarial",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Secretarial" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesParaprofessionals",
      label: "Salaries – Paraprofessionals",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Paraprofessionals" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesTechSupportInHouse",
      label: "Salaries – Technology Support (In-House)",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Technology Support (In-House)" }],
      group: "salaries",
      defaultVisible: false,
    },

    // Purchased Services
    {
      key: "svcTechnologySupport",
      label: "Technology Support",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Technology Support" }],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "svcEquipMaintAV",
      label: "Equipment Maintenance/AV",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "Equipment Maintenance/AV" },
      ],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "svcComputerMaintenance",
      label: "Computer Maintenance",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Computer Maintenance" }],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "svcVehicleLease",
      label: "Vehicle Lease",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "Vehicle Lease" },
        { block: "Other", key: "Vehicle Lease" },
      ],
      group: "services",
      defaultVisible: false,
    },

    // Supplies / Materials
    {
      key: "suppliesSoftware",
      label: "Software",
      valueType: "currency",
      sources: [{ block: "Supplies / Materials", key: "Software" }],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "suppliesSystemwide",
      label: "Supplies (Systemwide)",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Supplies (Systemwide)" },
      ],
      group: "materials",
      defaultVisible: false,
    },

    // Program / Staff Development
    {
      key: "devInServiceClassified",
      label: "In-Service, Classified",
      valueType: "currency",
      sources: [
        { block: "Program / Staff Development", key: "In-Service, Classified" },
      ],
      group: "development",
      defaultVisible: false,
    },
    {
      key: "devProfMtgsClassified",
      label: "Prof. Mtgs., Classified",
      valueType: "currency",
      sources: [
        {
          block: "Program / Staff Development",
          key: "Prof. Mtgs., Classified",
        },
      ],
      group: "development",
      defaultVisible: false,
    },
    {
      key: "devPlanetariumTraining",
      label: "Planetarium Training",
      valueType: "currency",
      sources: [
        {
          block: "Program / Staff Development",
          key: "Planetarium Training",
        },
      ],
      group: "development",
      defaultVisible: false,
    },

    // Other
    {
      key: "duesFees",
      label: "Dues/Fees",
      valueType: "currency",
      sources: [{ block: "Other", key: "Dues/Fees" }],
      group: "other",
      defaultVisible: false,
    },

    // Equipment
    {
      key: "equipReplacementProgram",
      label: "Technology Replacement Program",
      valueType: "currency",
      sources: [
        { block: "Equipment", key: "Technology Replacement Program" },
      ],
      group: "equipment",
      defaultVisible: false,
    },
    {
      key: "equipReplaceRepair",
      label: "Replace / Repair",
      valueType: "currency",
      sources: [{ block: "Equipment", key: "Replace/Repair" }],
      group: "equipment",
      defaultVisible: false,
    },
    {
      key: "equipNewAV",
      label: "New/AV Equipment",
      valueType: "currency",
      sources: [{ block: "Equipment", key: "New/AV Equipment" }],
      group: "equipment",
      defaultVisible: false,
    },
    {
      key: "equipNewTechRelated",
      label: "New Technology Related Equipment",
      valueType: "currency",
      sources: [
        { block: "Equipment", key: "New Technology Related Equipment" },
      ],
      group: "equipment",
      defaultVisible: false,
    },
    {
      key: "equipReplacementAV",
      label: "Replacement/AV Equipment",
      valueType: "currency",
      sources: [{ block: "Equipment", key: "Replacement/AV Equipment" }],
      group: "equipment",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "approvedMain",
      title: "3600 TECHNOLOGY SUPPORT SERVICES – Approved",
      sectionKey: "Approved",
      fields: [
        "positionsAdmin",
        "positionsCoordinators",
        "positionsTechSpecialists",
        "positionsSecretarial",
        "positionsParaprofessionals",
        "salariesAdmin",
        "salariesCoordinators",
        "salariesTechSpecialists",
        "salariesTechMaintenancePT",
        "salariesSecretarial",
        "salariesParaprofessionals",
        "salariesTechSupportInHouse",
        "svcTechnologySupport",
        "svcEquipMaintAV",
        "svcComputerMaintenance",
        "svcVehicleLease",
        "suppliesSoftware",
        "suppliesSystemwide",
        "devInServiceClassified",
        "devProfMtgsClassified",
        "devPlanetariumTraining",
        "duesFees",
        "equipReplacementProgram",
        "equipReplaceRepair",
        "equipNewAV",
        "equipNewTechRelated",
        "equipReplacementAV",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "120px" },
        positionsCoordinators: { minWidth: "120px" },
        positionsTechSpecialists: { minWidth: "200px" },
        positionsSecretarial: { minWidth: "120px" },
        positionsParaprofessionals: { minWidth: "145px" },

        // Salaries
        salariesAdmin: { minWidth: "130px" },
        salariesCoordinators: { minWidth: "130px" },
        salariesTechSpecialists: { minWidth: "170px" },
        salariesTechMaintenancePT: { minWidth: "190px" },
        salariesSecretarial: { minWidth: "120px" },
        salariesParaprofessionals: { minWidth: "150px" },
        salariesTechSupportInHouse: { minWidth: "190px" },

        // Purchased Services
        svcTechnologySupport: { minWidth: "120px" },
        svcEquipMaintAV: { minWidth: "170px" },
        svcComputerMaintenance: { minWidth: "130px" },
        svcVehicleLease: { minWidth: "90px" },

        // Supplies / Materials
        suppliesSoftware: { minWidth: "90px" },
        suppliesSystemwide: { minWidth: "120px" },

        // Program / Staff Development
        devInServiceClassified: { minWidth: "100px" },
        devProfMtgsClassified: { minWidth: "100px" },
        devPlanetariumTraining: { minWidth: "120px" },

        // Other
        duesFees: { minWidth: "90px" },

        // Equipment
        equipReplacementProgram: { minWidth: "200px" },
        equipReplaceRepair: { minWidth: "100px" },
        equipNewAV: { minWidth: "140px" },
        equipNewTechRelated: { minWidth: "180px" },
        equipReplacementAV: { minWidth: "140px" },
      },
    },
    {
      id: "actualMain",
      title: "3600 TECHNOLOGY SUPPORT SERVICES – Actual",
      sectionKey: "Actual",
      fields: [
        "positionsAdmin",
        "positionsCoordinators",
        "positionsTechSpecialists",
        "positionsSecretarial",
        "positionsParaprofessionals",
        "salariesAdmin",
        "salariesCoordinators",
        "salariesTechSpecialists",
        "salariesTechMaintenancePT",
        "salariesSecretarial",
        "salariesParaprofessionals",
        "salariesTechSupportInHouse",
        "svcTechnologySupport",
        "svcEquipMaintAV",
        "svcComputerMaintenance",
        "svcVehicleLease",
        "suppliesSoftware",
        "suppliesSystemwide",
        "devInServiceClassified",
        "devProfMtgsClassified",
        "devPlanetariumTraining",
        "duesFees",
        "equipReplacementProgram",
        "equipReplaceRepair",
        "equipNewAV",
        "equipNewTechRelated",
        "equipReplacementAV",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "130px" },
        positionsCoordinators: { minWidth: "140px" },
        positionsTechSpecialists: { minWidth: "170px" },
        positionsSecretarial: { minWidth: "130px" },
        positionsParaprofessionals: { minWidth: "170px" },

        // Salaries
        salariesAdmin: { minWidth: "130px" },
        salariesCoordinators: { minWidth: "140px" },
        salariesTechSpecialists: { minWidth: "170px" },
        salariesTechMaintenancePT: { minWidth: "190px" },
        salariesSecretarial: { minWidth: "130px" },
        salariesParaprofessionals: { minWidth: "170px" },
        salariesTechSupportInHouse: { minWidth: "210px" },

        // Purchased Services
        svcTechnologySupport: { minWidth: "180px" },
        svcEquipMaintAV: { minWidth: "190px" },
        svcComputerMaintenance: { minWidth: "180px" },
        svcVehicleLease: { minWidth: "150px" },

        // Supplies / Materials
        suppliesSoftware: { minWidth: "150px" },
        suppliesSystemwide: { minWidth: "170px" },

        // Program / Staff Development
        devInServiceClassified: { minWidth: "190px" },
        devProfMtgsClassified: { minWidth: "200px" },
        devPlanetariumTraining: { minWidth: "190px" },

        // Other
        duesFees: { minWidth: "130px" },

        // Equipment
        equipReplacementProgram: { minWidth: "230px" },
        equipReplaceRepair: { minWidth: "170px" },
        equipNewAV: { minWidth: "170px" },
        equipNewTechRelated: { minWidth: "240px" },
        equipReplacementAV: { minWidth: "210px" },
      },
    },
  ],

  inflationSumFields: null,
};

export function Program3600(props) {
  return (
    <ProgramBudget programId="3600" config={PROGRAM_3600_CONFIG} {...props} />
  );
}

export default Program3600;
